export default class WorkTypePricingMetricNames {
    static CREATE_ATTEMPT = "CreateWorkTypePricingAttempt";
    static CREATE_FAILURE = "CreateWorkTypePricingFailure";
    static GET_BY_WORK_TYPE_GROUP_ID_AND_ENTITY_ID_ATTEMPT = "getWorkTypePricingByWorkTypeGroupIdAndEntityIdAttempt";
    static GET_BY_WORK_TYPE_GROUP_ID_AND_ENTITY_ID_FAILURE = "getWorkTypePricingByWorkTypeGroupIdAndEntityIdFailure"
    static UPDATE_ATTEMPT = "UpdateWorkTypePricingAttempt";
    static UPDATE_FAILURE = "UpdateWorkTypePricingFailure";
};
